import "./App.css";
import WhatWeDo from "./WhatWeDo";
import IntroZone from "./IntroZone";
import greencheck from "./img/greencheck.svg";
import redx from "./img/redx.svg";
import InvestmentCriteria from "./InvestmentCriteria";
import Values from "./Values";
import Partnership from "./Partnership";
import Mission from "./Mission";
import Contact from "./Contact";

function App() {
  return (
    <div className="App">
      <IntroZone />
      <Mission />
      <WhatWeDo
        leftColumn={
          <>
            <p>
              <strong>We do:</strong>
            </p>
            <ul>
              <li>
                <img src={greencheck} />
                Provide access to additional capital for strategic growth and
                capital investments
              </li>
              <li>
                <img src={greencheck} />
                Engage experts and operating partners with deep industry
                knowledge to complement the investment team
              </li>
              <li>
                <img src={greencheck} />
                Tailor the transaction structure to suit the specific needs of
                the business owner
              </li>
            </ul>
          </>
        }
        rightColumn={
          <>
            <p>
              <strong>We do NOT:</strong>
            </p>
            <ul>
              <li>
                <img src={redx} />
                Rely on financial engineering to drive above-market returns
              </li>
              <li>
                <img src={redx} />
                Have one standard playbook that we apply across all of our
                investments
              </li>
              <li>
                <img src={redx} />
                Operate companies - we are investors, not managers; we empower
                management teams to execute on their visions
              </li>
            </ul>
          </>
        }
      />
      <InvestmentCriteria />
      <Values />
      <Partnership />
      <Contact />
    </div>
  );
}

export default App;
